import {BasicService} from '../../_base/services/basic.service';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_QUALITY_TYPE_URL } from '../../connection.data';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class QualityTypeService extends BasicService {
    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_QUALITY_TYPE_URL;
    }
}